<!--<div class="mock-home-page-header">-->
<!--  <img class="logo" [src]="logo ? logo : ''" />-->
<!--  <app-language-selection></app-language-selection>-->
<!--</div>-->
<ng-container *ngIf="IsExternalLogin else internal">
  <div class="content" dir="{{dir}}">
    <div class="form-wrapper" cpHideWhenPopupOpen>
      <app-login-external></app-login-external>
    </div>
  </div>
</ng-container>
<ng-template #internal>
  <div class="content" dir="{{dir}}">
    <div class="form-wrapper" cpHideWhenPopupOpen>
      <app-login-internal></app-login-internal>
    </div>
    <div kendoWindowContainer></div>
  </div>
</ng-template>
